import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from '../utility-services/auth.service';

export const authGuard: CanActivateFn = (route, state) => {
  const authService = inject(AuthService);
  const router = inject(Router);

  if (!authService.isAuthenticated) {
    authService.clearCookies();

    void router.navigate(['auth', 'sign-in'], {
      queryParams: {
        returnUrl: state.url,
      },
    });

    return false;
  }

  return true;
};
